import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';

const TITLE = "Décompte jusqu'au Nouvel An hégirien 2026 - Jours restants";
const DESCRIPTION = "Combien de jours restants jusqu'au Nouvel An hégirien 2026 ? Le décompte jusqu'au 1er Muharram 1448 AH vous fournit des informations précises sur la date du Nouvel An islamique, combien de jours restent jusqu'à cette occasion religieuse importante.";
const KEYWORDS = "Nouvel An hégirien 2026, 1er Muharram 1448, décompte Nouvel An islamique, date Nouvel An hégirien 2026, combien de jours jusqu'au Nouvel An hégirien";
const OG_URL = "https://do-calculate.com/articles-fr/hijri";

function HijriNewYear() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const initialDate = new Date("2026-06-27T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    const hijriDates = [
        { name: 'Nouvel An hégirien 2026 (1448 AH)', date: new Date("2026-06-27T00:00:00") },
        { name: 'Nouvel An hégirien 2027 (1449 AH)', date: new Date("2027-06-06T00:00:00") },
        { name: 'Nouvel An hégirien 2028 (1450 AH)', date: new Date("2028-05-25T00:00:00") },
        { name: 'Nouvel An hégirien 2029 (1451 AH)', date: new Date("2029-05-15T00:00:00") },
    ];

    const dayName = initialDate.toLocaleDateString('fr-FR', { weekday: 'long' });

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'au Nouvel An hégirien 2026
            </h1>
            <div>
                <BlinkingText text={`Décompte jusqu'au Nouvel An hégirien : le Nouvel An hégirien 1448 devrait commencer le ${dayName} 27/06/2026 (grégorien) correspondant au 1er Muharram 1448 (hégirien).`} />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                            Prochaines dates du Nouvel An hégirien
                        </h2>
                        <table style={{ fontSize: '20px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Événement</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hijriDates.map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{item.name}</td>
                                        <td style={{ padding: '12px' }}>{item.date.toLocaleDateString('fr-FR')}</td>
                                        <td style={{ padding: '12px' }}>
                                            {Math.max(0, calculateTimeLeft(item.date).days ?? 0)} jours
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Décompte jusqu'au Nouvel An hégirien 2026</h3>
                    <p>
                        Dans cet article, nous vous proposons un décompte détaillé jusqu'au Nouvel An hégirien, afin que vous puissiez être informé à tout moment du nombre de jours restants jusqu'à l'arrivée de cette occasion religieuse importante. Beaucoup d'entre nous se demandent combien de jours restent jusqu'au Nouvel An islamique. C'est pourquoi, dans cet article, nous vous présentons le décompte jusqu'au Nouvel An hégirien.
                    </p>
                    <p>
                        Le Nouvel An hégirien 1448 devrait commencer le {dayName} 27/06/2026 (grégorien) correspondant au 1er Muharram 1448 (hégirien). Vous pouvez voir le décompte dans cet article.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'au Nouvel An hégirien
                    </h3>
                    <p>
                        Grâce au programme de décompte du Nouvel An hégirien, vous pouvez savoir combien de jours restent jusqu'au 1er Muharram dans les calendriers grégorien et hégirien. Vous pouvez également découvrir combien de jours restent jusqu'au début de la nouvelle année islamique.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">Le Nouvel An hégirien</h3>
                    <p>
                        Le Nouvel An hégirien marque le début de l'année dans le calendrier islamique. Il correspond au 1er Muharram, premier mois de l'année hégirienne. Ce jour est particulièrement significatif dans l'histoire islamique car il commémore la Hijra (migration) du Prophète Muhammad (paix et bénédictions sur lui) de La Mecque à Médine, événement qui constitue le point de départ du calendrier hégirien. Les musulmans du monde entier marquent ce jour par la prière, la réflexion et la gratitude.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'au Nouvel An hégirien 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default HijriNewYear;
